import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Button,
  Typography,
} from "@mui/material";
import image from "../../image/hashtag-polaroid.jpg";

export function ConfirmAnnulePopup({ open, onClose, confirm }) {
  return (
    <Dialog open={open} fullWidth maxWidth="xs">
      <DialogTitle
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        Confirmer Annuler
      </DialogTitle>

      <DialogContent>
        <Typography>Confirmez-vous l'annulation ?</Typography>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Button variant="contained" color="error" onClick={onClose}>
            Annulé
          </Button>
          <Button
            variant="contained"
            onClick={confirm}
            sx={{ marginLeft: "2%" }}
          >
            Confirmez
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
